const linkLandingPagesValidationFR = {
    "add": {
        "title": {
            "required": "Le titre est requis",
            "length": "Le titre ne peut pas dépasser 32 caractères"
        },
        "short_description": {
            "length": "La description ne peut pas dépasser 80 caractères."
        },
        "back_url": {
            "required": "L'URL de retour est requise",
            "length": "L'URL de retour ne peut pas dépasser 10 caractères",
            "unique": "Oups ! Cette URL de retour est déjà associée à une autre page de destination. Veuillez essayer une autre URL de retour.",
            "available": "L'URL de retour est disponible",
            "invalid": "L'URL de retour est invalide"
        },
        "logo": {
            "required": "Le logo est requis",
            "dimensions": "La taille du logo doit être d'au moins 500 X 500 px et un ratio d'aspect 1:1, formats JPG/JPEG/PNG pris en charge.",
            "choose": "Veuillez choisir une image",
            "file": "Veuillez télécharger les formats JPG ou PNG, résolution minimale 500 X 500 px et un ratio d'aspect 1:1. Taille maximale 2MB"
        },
        "background_image": {
            "dimensions": "La taille de l'image de fond doit être d'au moins 1000 X 1000 px et un ratio d'aspect 1:1, formats JPG/JPEG/PNG pris en charge.",
            "choose": "Veuillez choisir une image",
            "file": "Veuillez télécharger les formats JPG ou PNG, résolution minimale 1000 X 1000 px et un ratio d'aspect 1:1. Taille maximale 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Facebook invalide"
        },
        "social_link_destination_url_instagram": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Instagram invalide"
        },
        "social_link_destination_url_twitter": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Twitter invalide"
        },
        "social_link_destination_url_youtube": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Youtube invalide"
        },
        "social_link_destination_url_tiktok": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL TikTok invalide"
        },
        "social_link_destination_url_linkedin": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL LinkedIn invalide"
        },
        "social_link_destination_url_other": {
            "regexp": "URL invalide"
        },
        "featured_link_title": {
            "required": "L'étiquette est requise",
            "length": "L'étiquette ne peut pas dépasser 100 caractères"
        },
        "featured_link_destination_url": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide"
        }
    },
    "update": {
        "title": {
            "required": "Le titre est requis",
            "length": "Le titre ne peut pas dépasser 32 caractères"
        },
        "short_description": {
            "length": "La description ne peut pas dépasser 80 caractères."
        },
        "back_url": {
            "required": "L'URL de retour est requise",
            "length": "L'URL de retour ne peut pas dépasser 10 caractères",
            "unique": "Oups ! Cette URL de retour est déjà associée à une autre page de destination. Veuillez essayer une autre URL de retour.",
            "available": "L'URL de retour est disponible",
            "invalid": "L'URL de retour est invalide"
        },
        "logo": {
            "required": "Le logo est requis",
            "dimensions": "La taille du logo doit être d'au moins 500 X 500 px et un ratio d'aspect 1:1, formats JPG/JPEG/PNG pris en charge.",
            "choose": "Veuillez choisir une image",
            "file": "Veuillez télécharger les formats JPG ou PNG, résolution minimale 500 X 500 px et un ratio d'aspect 1:1. Taille maximale 2MB"
        },
        "background_image": {
            "dimensions": "La taille de l'image de fond doit être d'au moins 1000 X 1000 px et un ratio d'aspect 1:1, formats JPG/JPEG/PNG pris en charge.",
            "choose": "Veuillez choisir une image",
            "file": "Veuillez télécharger les formats JPG ou PNG, résolution minimale 1000 X 1000 px et un ratio d'aspect 1:1. Taille maximale 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Facebook invalide"
        },
        "social_link_destination_url_instagram": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Instagram invalide"
        },
        "social_link_destination_url_twitter": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Twitter invalide"
        },
        "social_link_destination_url_youtube": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL Youtube invalide"
        },
        "social_link_destination_url_tiktok": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL TikTok invalide"
        },
        "social_link_destination_url_linkedin": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide",
            "invalid": "URL LinkedIn invalide"
        },
        "social_link_destination_url_other": {
            "regexp": "URL invalide"
        },
        "featured_link_title": {
            "required": "L'étiquette est requise",
            "length": "L'étiquette ne peut pas dépasser 100 caractères"
        },
        "featured_link_destination_url": {
            "required": "L'URL de destination est requise",
            "regexp": "URL invalide"
        }
    }
};

export default linkLandingPagesValidationFR;